import {
    AnimationBaseController,
    GameRandom,
    Key,
} from "../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../Models/GameModel";
import { AnimationContents } from "../AnimationContents";
import { GameLogic } from "../../Logic/GameLogic";
import { PlayerController } from "./Player/PlayerController";
import { BgSimpleTileContainerController, IBgSimpleTileContainerControllerOptions } from "./BgSimpleTileContainerController";
import { BgCollisionContainerController } from "./BgCollisionContainerController";
import { UIController, IUIControllerOptions } from "./UI/UIController";
import { ContinueLabelController } from "./ContinueLabelController";
import { PrizeEffectController } from "./PrizeEffectController";
import { Rectangle } from "pixi.js";

export interface IGameControllerOptions {
}

export class GameController extends AnimationBaseController {
    $model: GameModel;
    // private _readyToContinue = true;

    public constructor(@Inject private _options: IGameControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("GameController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: "scene",
            childControllers: {
                BgCloudContainer: {
                    model: this.$model.cloudContainer,
                    controller: BgSimpleTileContainerController,
                    options: <IBgSimpleTileContainerControllerOptions>{
                        tileName: 'cloud_1'
                    },
                    y: -1200
                },
                BgBackCityContainer: {
                    model: this.$model.backCityContainer,
                    controller: BgSimpleTileContainerController,
                    options: <IBgSimpleTileContainerControllerOptions>{
                        tileName: 'back_stage_1'
                    },
                    y: -440
                },
                BgMainCityContainer: {
                    model: this.$model.mainCityContainer,
                    controller: BgSimpleTileContainerController,
                    options: <IBgSimpleTileContainerControllerOptions>{
                        tileName: 'middle_stage_1'
                    },
                    y: -600
                },
                BgFloorContainer: {
                    model: this.$model.bgContainer,
                    controller: BgSimpleTileContainerController,
                    options: <IBgSimpleTileContainerControllerOptions>{
                        tileName: 'floor'
                    },
                    y: 580
                },
                BgFenceContainer: {
                    model: this.$model.fenceContainer,
                    controller: BgSimpleTileContainerController,
                    options: <IBgSimpleTileContainerControllerOptions>{
                        tileName: 'fence'
                    },
                    x: -150,
                    y: 0
                },
                BgCollisionContainer: {
                    model: this.$model.bgCollisionContainer,
                    controller: BgCollisionContainerController
                },
                Player: {
                    model: this.$model,
                    controller: PlayerController
                },
                UIContainer: {
                    model: this.$model,
                    controller: UIController,
                    options: <IUIControllerOptions>{

                    },
                },
                ContinueLabel: {
                    model: this.$model,
                    controller: ContinueLabelController,
                    options: {
                        onComplete: () => {
                            this._gameLogic.hideModal();
                            this._gameLogic.gameTap();
                        }
                    }
                }
            },
            modelWatch: {
                "player.isFall": (isFall: boolean) => {
                    console.log('modelWatch', isFall, this.$model.startNewGame);

                    if (isFall && this.$model.player.lives) {
                        // this._readyToContinue = false;
                        this.$queue.get('continueLabel').addToQueue();
                    } else if (!isFall) {
                        this.$childControllers.get<ContinueLabelController>('ContinueLabel').visible = false;
                    }
                },
            },
            queue: {
                continueLabel: {
                    condition: (time: number) => {
                        return time > 0.5
                    },
                    action: () => {
                        const controller = this.$childControllers.get<ContinueLabelController>('ContinueLabel');
                        controller.visible = true;
                        controller.play();
                    }
                }
            },
            // onPointerDown: ()=>{
            //     this._onTap();
            // },
            // onTap: (e) => {
            //     this._onTap();
            // },
            keyboard: {
                [Key["SPACE"]]: {
                    pressed: () => {
                        this._onTap();
                    },
                    released: () => {
                    },
                    down: () => {
                    },
                }
            },
        };
    }

    protected onInitialize(): void {
        this.$childControllers.get<ContinueLabelController>('ContinueLabel').visible = false;
        this.container.children[0].interactive = true;
        this.container.children[0].on("pointerdown", this._onTap.bind(this));
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
        if (this.$model.pause) {
            return;
        }
        this._gameLogic.update(frameRate);
    }

    protected onResize(width: number, height: number, scale: number): void {
        const W = width / scale;
        const H = height / scale;

        this.x = -W / 2 + this.$model.cameraPos.x;
        this.y = H / 2 + this.$model.cameraPos.y;
        this.scaleX = this.scaleY = this.$model.cameraZoom;
        //this.container.children[0].hitArea = new Rectangle(0, -H/2 + this.y, W/this.scaleX, H/this.scaleX);
        this.container.children[0].hitArea = new Rectangle(-2500, -2500, 5000, 5000);
    }

    private _onTap() {
        if (!this.$model.player.isFall && !this.$model.pause) {
            this._gameLogic.hideModal();
            this._gameLogic.gameTap();
        }
    }
}

